export default __webpack_public_path__ + "static/media/4-TranquilMooring.0c4813e9.jpeg";